import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteDesignation } from "../../../axios/Designation/DesignationApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const RemoveDesignationDialog = ({ onClose, onRefresh, row }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose();
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const payload = {
        id: row.id,
        langId: localStorage.getItem("i18nextLngId"),
      };
      const response = await deleteDesignation(payload);

      if (response?.data === "") {
        onClose();
        toast.success(t("common.delete-designation-successfully"));
        onRefresh?.();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t("common.network-timeout"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="delete"
      title={t("common.remove-designation")}
      subtitle={t("common.are-you-sure-delete-this-designation")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleDelete}
    />
  );
};

export default RemoveDesignationDialog;
